import React from "react"
import { Grid, Divider, Item } from "semantic-ui-react"
import TooltipGridRow from "./TooltipGridRow"
import { formattedPhone, displayField } from "../../../utils/utils"

export default class DetailsTab extends React.Component {
  labels(data, width) {
    return (
      <Grid.Column width={width}>
        {data.map((label, i) => (
          <Item key={`details-label-${i}`}>
            <strong>{label}</strong>
          </Item>
        ))}
      </Grid.Column>
    )
  }

  items(data, width) {
    return (
      <Grid.Column width={width}>
        {data.map((item, i) => (
          <Item key={`details-item-${i}`}>{displayField(item)}</Item>
        ))}
      </Grid.Column>
    )
  }

  render() {
    const { customer, vehicle, shop, localAppointmentDatetime } = this.props
    const { full_name, cellPhone, email } = customer
    const { year, make, model, vin, miles } = vehicle
    const { id, name, main_phone_number, address_line1, city, state, zip } = shop

    const customerData = [
      { label: "Customer:", attr: full_name },
      { label: "Cell:", attr: formattedPhone(cellPhone) },
      { label: "Email:", attr: email },
      { label: "User Role:", attr: customer.roles_name }

    ]
    const vehicleData1 = {
      labels: ["Year:", "Make:", "Model:"],
      items: [year, make, model]
    }
    const vehicleData2 = {
      labels: ["VIN:", "Miles:"],
      items: [vin, miles]
    }
    const shopData = [
      { label: "Shop:", attr: name },
      { label: "Phone:", attr: formattedPhone(main_phone_number) },
      { label: "Address:", attr: address_line1 },
      {
        label: "",
        attr: `${displayField(city)} ${displayField(state)} ${displayField(
          zip
        )}`
      },
      { label: "Local Appt Time:", attr: localAppointmentDatetime }
    ]

    return (
      <React.Fragment>
        <React.Fragment>
          <Grid style={{ paddingTop: "15px", paddingBottom: "15px" }}>
            <TooltipGridRow
              id={id}
              data={customerData}
              labelWidth={3}
              attrWidth={5}
            />
          </Grid>
          <Divider />
          <Grid>
            {this.labels(vehicleData1.labels, 3)}
            {this.items(vehicleData1.items, 5)}
            {this.labels(vehicleData2.labels, 2)}
            {this.items(vehicleData2.items, 6)}
          </Grid>
          <Divider />
          <Grid style={{ paddingTop: "15px", paddingBottom: "15px" }}>
            <TooltipGridRow  id={id} data={shopData} labelWidth={4} attrWidth={12} />
          </Grid>
        </React.Fragment>
      </React.Fragment>
    )
  }
}
